import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createCommandeFromSelectedItems } from '../api/commandeService';
import swal from 'sweetalert';
import useOrder from '../hooks/useOrder';

const CheckoutPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { removeItemsFromCartByIds } = useOrder();

  const selectedItems = state?.selectedOrders || [];
  const totalPrice = state?.totalPrice || 0;

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    address: '',
    province: '',
    zipCode: '',
    phoneNumber: '',
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  const now = new Date();

  const items = selectedItems.map(item => {
    const {
      id,
      quantity,
      initialPrice,
      promoStartDate,
      promoEndDate,
      promoPercentage
    } = item;

    const promoStart = promoStartDate ? new Date(promoStartDate) : null;
    const promoEnd = promoEndDate ? new Date(promoEndDate) : null;

    const isPromoActive =
      promoPercentage &&
      promoPercentage > 0 &&
      promoStart &&
      now >= promoStart &&
      (!promoEnd || now <= promoEnd);

    const price = isPromoActive
      ? Number((initialPrice * (1 - promoPercentage / 100)).toFixed(2))
      : initialPrice;

    return {
      product: id,
      quantity,
      price, // Optional: send price with each item for logging/storing
      total: price * quantity,
    };
  });

  const subTotal = items.reduce((sum, item) => sum + item.total, 0);
  const deliveryFee = 7;
  const finalTotal = subTotal + deliveryFee;

  const payload = {
    ...form,
    phoneNumber: `+216${form.phoneNumber}`,
    user: localStorage.getItem('client_id'),
    reference: crypto.randomUUID(),
    items: items.map(({ product, quantity }) => ({ product, quantity })), // send only needed fields
    subTotal,
    deliveryFee,
    totalPrice: finalTotal,
  };

  const result = await createCommandeFromSelectedItems(payload);

  setIsLoading(false);

  if (result) {
    const orderedIds = selectedItems.map(item => item.id);
    await removeItemsFromCartByIds(orderedIds);

    swal('Commande passée avec succès!', '', 'success').then(() => {
      navigate('/orders');
    });
  } else {
    swal('Erreur', 'La commande a échoué. Réessayez.', 'error');
  }
};



  return (
    <section className="max-w-screen-xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-12 relative">
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <img src="/assets/loading.gif" alt="Chargement..." className="w-28 h-28" />
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        className="space-y-5 bg-white p-8 rounded-xl shadow-md border border-gray-200"
      >
        <h2 className="text-2xl font-semibold text-paragaia mb-4 poppins">
          Informations de livraison
        </h2>

        {[
          { name: 'firstName', label: 'Prénom' },
          { name: 'lastName', label: 'Nom' },
          { name: 'address', label: 'Adresse' },
          { name: 'province', label: 'Gouvernorat' },
          { name: 'zipCode', label: 'Code Postal' },
        ].map(({ name, label }) => (
          <input
            key={name}
            name={name}
            placeholder={label}
            required
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-paragaia"
          />
        ))}

        <input
          name="phoneNumber"
          placeholder="Numéro de téléphone (8 chiffres)"
          required
          pattern="\d{8}"
          maxLength={8}
          title="Entrez exactement 8 chiffres"
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-paragaia"
        />

        <button
          type="submit"
          className="w-full bg-paragaia text-white py-3 rounded-lg hover:bg-[#b36b9b] transition font-semibold"
        >
          Confirmer la commande
        </button>
      </form>

      {/* Right: Résumé */}
      <div className="bg-paragaiaLight p-6 rounded-xl shadow-md h-fit">
        <h2 className="text-xl font-semibold text-paragaia mb-4 poppins">
          Résumé de la commande
        </h2>

        <ul className="space-y-4">
          {selectedItems.map((item) => (
            <li key={item.id} className="flex items-center gap-4">
              <img
                src={item.image || '/assets/no-image.png'}
                alt={item.name}
                className="w-16 h-16 object-cover rounded-md border"
              />
              <div className="flex-1">
                <p className="text-gray-800 font-medium">{item.name}</p>
                <p className="text-sm text-gray-500">
                  Quantité: {item.quantity} × {item.price.toFixed(2)} TND
                </p>
              </div>
              <div className="text-paragaia font-semibold">
                {(item.quantity * item.price).toFixed(2)} TND
              </div>
            </li>
          ))}
        </ul>

        <div className="border-t mt-6 pt-4 text-sm text-gray-700 space-y-2">
          <div className="flex justify-between">
            <span>Sous-total</span>
            <span>{totalPrice.toFixed(2)} TND</span>
          </div>
          <div className="flex justify-between">
            <span>Livraison</span>
            <span>7.00 TND</span>
          </div>
          <div className="flex justify-between font-bold text-paragaia text-base mt-2">
            <span>Total</span>
            <span>{(totalPrice + 7).toFixed(2)} TND</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CheckoutPage;
